const BODYLESS_RESPONSE_STATUSES = new Set([204, 205, 304]);

/**
 * Construct a Fetch Response safely for all status codes.
 * For bodyless statuses (204/205/304), Response requires a null body.
 */
export const createSafeResponse = (
	body: BodyInit | null,
	init: ResponseInit & { status: number }
): Response => {
	if (BODYLESS_RESPONSE_STATUSES.has(init.status)) {
		return new Response(null, init);
	}

	return new Response(body, init);
};
